(() => {
  const init = (header) => {
    if (!header || header.dataset.initialized === 'true') return;
    header.dataset.initialized = 'true';
    const button = header.querySelector('[data-drk-global-menu-button]');
    const nav = header.querySelector('[data-drk-global-mobile-nav]');
    const groups = [...header.querySelectorAll('details')];
    if (!button || !nav) return;
    const closeGroups = (except) => groups.forEach((group) => { if (group !== except) group.open = false; });
    const close = (restore = false) => {
      button.setAttribute('aria-expanded', 'false');
      nav.hidden = true;
      closeGroups();
      if (restore) button.focus();
    };
    groups.forEach((group) => group.addEventListener('toggle', () => { if (group.open) closeGroups(group); }));
    button.addEventListener('click', () => {
      const opening = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(opening));
      nav.hidden = !opening;
      if (!opening) closeGroups();
    });
    nav.addEventListener('click', (event) => { if (event.target.closest('a')) close(); });
    document.addEventListener('click', (event) => { if (!header.contains(event.target)) closeGroups(); });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!nav.hidden) close(true); else closeGroups();
    });
    window.addEventListener('resize', () => { if (window.innerWidth > 1120 && !nav.hidden) close(); }, { passive: true });
  };
  document.querySelectorAll('[data-drk-global-header]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-drk-global-header]')));
})();
